import React, {useEffect, useState} from 'react';
import {LessonPlan} from "types/LessonPlan";
import ConfirmModal from "components/ConfirmModal";
import {invalidate} from "services/query-client";
import {useMutation} from "react-query";
import ngage from "services/ngage";

type Props = {
    lessonPlan?: LessonPlan | null
    show: boolean
    onDelete?: (lessonPlan: LessonPlan) => any
    onDeleteFail?: (lessonPlan: LessonPlan, error: unknown) => any
    onCancel?: () => any
}

function DeleteLessonPlan(props: Props) {
    const {lessonPlan, show, onDelete, onDeleteFail, onCancel} = props

    const [name, setName] = useState<string>(lessonPlan?.name || 'this lesson plan');
    const {mutateAsync: deleteLessonPlan} = useMutation(ngage.lessonPlans.destroy)

    useEffect(() => {
        if(lessonPlan) setName(lessonPlan.name)
    }, [lessonPlan]);

    async function handleDeleteLessonPlan() {
        if (lessonPlan) {
            try {
                await deleteLessonPlan(lessonPlan.id)
                await invalidate('lesson-plans.all')

                if (onDelete) onDelete(lessonPlan)
            } catch (error) {
                if (onDeleteFail) onDeleteFail(lessonPlan, error)
            }
        }
    }

    function handleCancel() {
        if (onCancel) onCancel()
    }

    return (
        <ConfirmModal
            show={show}
            type={ConfirmModal.types.DANGER}
            title="Delete Lesson Plan"
            body={`Are you sure you want to permanently delete '${name}'? This action cannot be undone.`}
            approveLabel="Delete"
            onApprove={handleDeleteLessonPlan}
            onCancel={handleCancel}
        />
    );
}

export default DeleteLessonPlan;